import router from './router'
import store from './store'
import { Message } from 'element-ui'
import { getAccount } from './utils/auth' // get token from cookie

const whiteList = ['/login', '/auth-redirect', '/forgotPwd', '/forgotPwdL2'] // no redirect whitelist

router.beforeEach(async(to, from, next) => {
  // start progress bar

  // set page title
//   document.title = getPageTitle(to.meta.title)

  // determine whether the user has logged in
  const hasAccount = getAccount()
  if (hasAccount) {
    if (to.path === '/login') {
      next()
    } else {
      // determine whether the user has obtained his permission roles through getInfo
	  const hasRoles = store.getters.roles && store.getters.roles.length > 0
      if (hasRoles) {
        next()
      } else {
        try {

          // get user info
		  // note: roles must be a object array! such as: ['admin'] or ,['developer','editor']
          const roles = await store.dispatch('user/getInfo')
          // generate accessible routes map based on roles
          const accessRoutes = await store.dispatch('permission/generateRoutes', roles)

          // dynamically add accessible routes
          router.addRoutes(accessRoutes)

          // hack method to ensure that addRoutes is complete
          // set the replace: true, so the navigation will not leave a history record
          next({ ...to, replace: true })
        } catch (error) {
          // remove token and go to login page to re-login
          await store.dispatch('user/resetAccount')
          Message.error(error || 'Has Error')
          next(`/login?redirect=${to.path}`)
        }
      }
    }
  } else {
    /* has no account*/

    if (whiteList.indexOf(to.path) !== -1) {
      // in the free login whitelist, go directly
      next()
    } else {
      // other pages that do not have permission to access are redirected to the login page.
      next(`/login?redirect=${to.path}`)
    }
  }
})

router.afterEach(() => {
})



// WEBPACK FOOTER //
// ./src/permission.js